import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FlatPickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  setSortFieldTicket,
  setOrderTicket,
  setCurrentPageTicket,
  setValueTicket,
  setSelectedOptionsTicket,
  setEnAttenteValidationTicket,
  setEnCoursTicket,
  setCorrigerTicket,
  setLivreTicket,
  setValideTicket,
  setACorrigerTicket,
  setAnnulerTicket,
  setDateTicket,
  setTypeTicket,
  setCriticiteTicket,
  setStatutLivTicket,
  setStatutReqTicket,
} from "../../store/actions";
import InputMask from "react-input-mask";
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "../../components/Common/DeleteModal";
import ReactPaginate from "react-paginate";
//redux

import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "./useDebounce";
import { useNavigate } from "react-router-dom";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";
import LastModificationAlert from "components/Common/Alert";
function TicketsList() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const badgeStyle = { fontSize: "100%" };
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [loading, setLoading] = useState(true);
  //   const investData = useSelector((state) => state.Investisseurs.investData);
  const [investData, setInvestData] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);
  const [redirectToLoginPage, setRedirect] = useState(false);

  // Pagination

  const currentPage = useSelector((state) => state.FiltreTickets.currentPage);
  const itemsPerPage = 20; // Limite d'affichage par page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentItems = investData.slice(indexOfFirstItem, indexOfLastItem);
  //Recherche
  const value = useSelector((state) => state.FiltreTickets.value);
  const enAttenteValidation = useSelector(
    (state) => state.FiltreTickets.enAttenteValidation
  );
  const a_corriger = useSelector((state) => state.FiltreTickets.aCorriger);
  const corrige = useSelector((state) => state.FiltreTickets.corrige);
  const en_cours = useSelector((state) => state.FiltreTickets.enCours);
  const livre = useSelector((state) => state.FiltreTickets.livre);
  const valide = useSelector((state) => state.FiltreTickets.valide);
  const annule = useSelector((state) => state.FiltreTickets.annule);
  const date = useSelector((state) => state.FiltreTickets.date);
  const statutLiv = useSelector((state) => state.FiltreTickets.statutLiv);
  const criticity = useSelector((state) => state.FiltreTickets.criticite);
  const statutReq = useSelector((state) => state.FiltreTickets.statutReq);
  const type = useSelector((state) => state.FiltreTickets.type);

  const debounceSearch = useDebounce(value, 500);
  const debounceDate = useDebounce(date, 500);
  // Triage
  const handleSorting = async (sortField, sortOrder) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_tickets?page=1&sort_by=${sortField}_${sortOrder}&key=${value}&date=${debounceDate}&fx_ticket_type_id=${type}&criticity=${criticity}&delivery_status=${statutLiv}&fx_ticket_status_id=${statutReq}&en_cours=${en_cours}&corrige=${corrige}&livre=${livre}&en_attente_de_validation=${enAttenteValidation}&valide=${valide}&annule=${annule}&a_corriger=${a_corriger}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newData = await response.json();
      const upData = newData;
      setInvestData(upData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  //Thead
  const sortField = useSelector((state) => state.FiltreTickets.sortField);
  const order = useSelector((state) => state.FiltreTickets.order);
  const [isSorting, setIsSorting] = useState(false);
  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageTicket(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";

    dispatch(setSortFieldTicket(accessor));
    dispatch(setOrderTicket(sortOrder));

    handleSorting(accessor, sortOrder); // Appel à la fonction de tri
    setIsSorting(false);
  };

  //meta title
  document.title = "Tickets | DOM COM";

  // validation

  //   useEffect(() => {

  //     if (token) {
  //       dispatch(fetchInvestRequest(token));
  //     }
  //   }, [dispatch, token]);
  useEffect(() => {
    if (redirectToLoginPage == true) {
      localStorage.removeItem("auth_token_" + api);
      localStorage.removeItem("authUser_" + api);
      localStorage.removeItem("sideBar_" + api);
      navigate(`${backUrl}/login`);
      window.location.reload(false);
    }
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, [redirectToLoginPage, navigate]);
  const fetchPage = async (currentPage) => {
    try {
      const res = await fetch(
        `https://www.fluxod.com/${api}/fx_tickets?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&date=${debounceDate}&fx_ticket_type_id=${type}&criticity=${criticity}&delivery_status=${statutLiv}&fx_ticket_status_id=${statutReq}&en_cours=${en_cours}&corrige=${corrige}&livre=${livre}&en_attente_de_validation=${enAttenteValidation}&valide=${valide}&annule=${annule}&a_corriger=${a_corriger}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let currentPage = data.selected + 1;
    const getData = await fetchPage(currentPage);
    dispatch(setCurrentPageTicket(currentPage));
    setInvestData(getData);
  };
  // Filtre

  const [filterParams, setFilterParams] = useState("");

  // Mettre à jour les paramètres de filtre et déclencher la fonction de filtrage avec débordement

  // Fonction pour mettre à jour l'état du filtre et appeler la mise à jour des paramètres accumulés
  const handleFilterChange = (accessor, value) => {
    const updatedFilters = investData.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return {
          ...filter,
          value: value,
        };
      }
      return filter;
    });

    setInvestData((prevData) => ({
      ...prevData,
      filters: updatedFilters,
    }));

    // Mettre à jour les paramètres de filtre
  };

  // La fonction de filtrage reste inchangée, elle utilise les paramètres de filtre accumulés
  const handleFiltering = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_tickets?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&date=${debounceDate}&fx_ticket_type_id=${type}&criticity=${criticity}&delivery_status=${statutLiv}&fx_ticket_status_id=${statutReq}&en_cours=${en_cours}&corrige=${corrige}&livre=${livre}&en_attente_de_validation=${enAttenteValidation}&valide=${valide}&annule=${annule}&a_corriger=${a_corriger}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      // if (!response.ok) {
      //   redirectToLoginPage = true;

      //   throw new Error("La réponse du réseau n'est pas valide");
      // }

      const newData = await response.json();
      setInvestData(newData);
      console.log(newData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données : ", error);
    }
  };

  const renderFilters = () => {
    const handleFilterValidation = () => {
      handleFiltering(investData.filters);
    };

    return (
      <>
        {!loading ? (
          <>
            {investData?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <input
                        defaultValue={value}
                        className="form-control mb-3 mb-xxl-0"
                        type="text"
                        placeholder={filter.label}
                        onChange={(e) => {
                          dispatch(setValueTicket(e.target.value));
                          dispatch(setCurrentPageTicket(1));
                          handleFilterChange(filter.accessor, value);
                        }}
                      />
                    </Col>
                  );
                case "date":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <InputMask
                        mask="9999-99-99"
                        defaultValue={date}
                        className="form-control input-color"
                        placeholder="YYYY-mm-dd"
                        onChange={(e) => {
                          dispatch(setDateTicket(e.target.value)),
                            dispatch(setCurrentPageTicket(1));
                          handleFilterChange(filter.accessor, date);
                        }}
                      />
                    </Col>
                  );
                case "fx_ticket_type_id":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        defaultValue={type}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setTypeTicket(e.target.value)),
                            dispatch(setCurrentPageTicket(1));
                          handleFilterChange(filter.accessor, type);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "criticity":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setCriticiteTicket(e.target.value)),
                            dispatch(setCurrentPageTicket(1));
                          handleFilterChange(filter.accessor, criticity);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "delivery_status":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setStatutLivTicket(e.target.value)),
                            dispatch(setCurrentPageTicket(1));
                          handleFilterChange(filter.accessor, statutLiv);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "fx_ticket_status_id":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setStatutReqTicket(e.target.value)),
                            dispatch(setCurrentPageTicket(1));
                          handleFilterChange(filter.accessor, statutReq);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );

                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_tickets?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&date=${debounceDate}&fx_ticket_type_id=${type}&criticity=${criticity}&delivery_status=${statutLiv}&fx_ticket_status_id=${statutReq}&en_cours=${en_cours}&corrige=${corrige}&livre=${livre}&en_attente_de_validation=${enAttenteValidation}&valide=${valide}&annule=${annule}&a_corriger=${a_corriger}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        // if (!response.ok) {
        //   setRedirect(true);
        //   throw new Error("La réponse du réseau n'est pas valide");
        // }

        const newData = await response.json();
        setInvestData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    handleFiltering();
  }, []);

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_tickets?page=1&sort_by=${sortField}_${order}&key=${debounceSearch}&date=${debounceDate}&fx_ticket_type_id=${type}&criticity=${criticity}&delivery_status=${statutLiv}&fx_ticket_status_id=${statutReq}&en_cours=${en_cours}&corrige=${corrige}&livre=${livre}&en_attente_de_validation=${enAttenteValidation}&valide=${valide}&annule=${annule}&a_corriger=${a_corriger}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   setRedirect(true);
        //   throw new Error("La réponse du réseau n'est pas valide");
        // }
        dispatch(setCurrentPageTicket(1));
        const newData = await response.json();
        setInvestData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    if (currentPage === 1) {
      handleFiltering();
    }
  }, [
    debounceSearch,
    type,
    enAttenteValidation,
    en_cours,
    corrige,
    a_corriger,
    livre,
    valide,
    statutLiv,
    statutReq,
    annule,
    criticity,
    debounceDate,
  ]);

  const selectedOptions = useSelector(
    (state) => state.FiltreTickets.selectedOptions
  );

  const options = [
    { value: "en_attente_validation", label: "En attente de validation" },
    {
      label: "En cours",
      value: "en_cours",
    },
    {
      label: "Corrigé",
      value: "corrige",
    },
    {
      label: "Livré",
      value: "livre",
    },
    {
      label: "Validé",
      value: "valide",
    },
    {
      label: "Annulé",
      value: "annule",
    },
    {
      label: "A corriger",
      value: "a_corriger",
    },
  ];

  const handleChange = (selected) => {
    const isEnAttenteValidationSelected = selected.some(
      (option) => option.value === "en_attente_validation"
    );
    const isEnCoursSelected = selected.some(
      (option) => option.value === "en_cours"
    );
    const isCorrigeSelected = selected.some(
      (option) => option.value === "corrige"
    );
    const isLivreSelected = selected.some((option) => option.value === "livre");

    const isValidSelected = selected.some(
      (option) => option.value === "valide"
    );
    const isAnnuleSelected = selected.some(
      (option) => option.value === "annule"
    );
    const isACorrigerSelected = selected.some(
      (option) => option.value === "a_corriger"
    );

    dispatch(setSelectedOptionsTicket(selected));

    dispatch(setCurrentPageTicket(1));

    dispatch(
      setEnAttenteValidationTicket(isEnAttenteValidationSelected ? 1 : 0)
    );
    handleFilterChange("en_attente_validation", isEnAttenteValidationSelected);

    dispatch(setEnCoursTicket(isEnCoursSelected ? 1 : 0));
    handleFilterChange("en_cours", isEnCoursSelected);

    dispatch(setCorrigerTicket(isCorrigeSelected ? 1 : 0));
    handleFilterChange("corrige", isCorrigeSelected);

    dispatch(setLivreTicket(isLivreSelected ? 1 : 0));
    handleFilterChange("livre", isLivreSelected);

    dispatch(setValideTicket(isValidSelected ? 1 : 0));
    handleFilterChange("valide", isValidSelected);

    dispatch(setAnnulerTicket(isAnnuleSelected ? 1 : 0));
    handleFilterChange("annule", isAnnuleSelected);

    dispatch(setACorrigerTicket(isACorrigerSelected ? 1 : 0));
    handleFilterChange("a_corriger", isACorrigerSelected);
  };
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);
  return (
    <React.Fragment>
      {/* <DeleteModal
       show={deleteModal}
       onDeleteClick={}
       onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        {previousPath == `${backUrl}/fx_tickets/${lastId}/edit` ? (
          <LastModificationAlert path={"fx_tickets"} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Tickets ({loading ? "--" : investData?.total_records})
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {investData?.can_add ? (
                        <Link
                          to={`${backUrl}/fx_tickets/new`}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-plus"></i>Ajouter
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {/* <Link to="#!" className="btn btn-sm btn-light me-1">
                        <i className="mdi mdi-export-variant"></i>Exporter
                      </Link> */}
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">
                        {renderFilters()}

                        <Col>
                          <Select
                            value={selectedOptions}
                            onChange={handleChange}
                            options={[...options]}
                            isMulti
                            placeholder="Filtres prédéfinis"
                          />
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="table-responsive">
                    {!loading ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              {investData?.can_edit === false &&
                              investData?.can_show === false &&
                              investData?.can_destroy === false ? (
                                <th></th>
                              ) : (
                                <th
                                  style={{ cursor: "default" }}
                                  key="Action"
                                  className="text"
                                >
                                  Action
                                </th>
                              )}

                              {investData?.headers?.map(
                                ({ label, accessor, sortable }) => {
                                  const cl = sortable ? (
                                    sortField === accessor ? (
                                      order === "asc" ? (
                                        <i className="bx bx-up-arrow-alt"></i>
                                      ) : (
                                        <i className="bx bx-down-arrow-alt"></i>
                                      )
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  );
                                  return (
                                    <th
                                      key={accessor}
                                      onClick={
                                        sortable
                                          ? () => handleSortingChange(accessor)
                                          : null
                                      }
                                      //className="text-nowrap"
                                      style={{
                                        width: "auto",
                                        cursor: sortable
                                          ? "pointer"
                                          : "default",
                                      }}
                                    >
                                      {label}
                                      {cl}
                                    </th>
                                  );
                                }
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {investData?.data?.map((rowData, rowIndex) => (
                              <tr key={rowIndex}>
                                <td key={rowIndex}>
                                  <ul className="list-unstyled hstack gap-1 mb-0">
                                    {investData?.can_show ? (
                                      <li
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="View"
                                      >
                                        <Link
                                          className="btn btn-sm btn-soft-primary"
                                          id="viewtooltip-2"
                                          to={`${backUrl}/fx_tickets/${rowData.id}`}
                                        >
                                          <i className="mdi mdi-eye-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {investData?.can_edit ? (
                                      <li title="Editer">
                                        <Link
                                          className="btn btn-sm btn-soft-info"
                                          id="edittooltip-2"
                                          to={`${backUrl}/fx_tickets/${rowData.id}/edit`}
                                          state={{ active: "details" }}
                                        >
                                          <i className="mdi mdi-pencil-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {investData?.can_destroy ? (
                                      <li title="Supprimer">
                                        <DeleteButton
                                          url={`${backUrl}/fx_tickets/${rowData.id}`}
                                        />
                                      </li>
                                    ) : null}
                                  </ul>
                                </td>
                                {investData?.headers?.map(
                                  ({ label, accessor }) => (
                                    <>
                                      {rowData[accessor] === "Faible" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="bg-warning badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : label === "Pièce jointe" &&
                                        rowData[accessor] != null ? (
                                        <td
                                          style={{
                                            width: "auto",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          <a href={rowData[accessor]} download>
                                            <i
                                              style={{
                                                fontSize: "25px",
                                                paddingLeft: "8px",
                                                textalign: "center",
                                                verticalalign: "middle",
                                              }}
                                              className="bx bx-download"
                                            ></i>
                                          </a>
                                        </td>
                                      ) : label === "Description" ? (
                                        <td
                                          className="text-truncate"
                                          style={{
                                            maxWidth: "25em",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor] || "——"}
                                        </td>
                                      ) : rowData[accessor] === "Moyen" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="bg-info badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "A faire" ||
                                        rowData[accessor] ===
                                          "En attente de validation" ||
                                        rowData[accessor] === "En cours" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="badge-soft-info badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "Annulé" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="badge-soft-danger badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "Oui" ||
                                        rowData[accessor] === "Validé" ||
                                        rowData[accessor] === "Fait" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="badge-soft-success badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "Élevé" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="bg-danger badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            width: "auto",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor] || "——"}
                                        </td>
                                      )}
                                    </>
                                  )
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={400} />
                    )}
                  </div>
                </CardBody>
                <div className="d-flex justify-content-center mt-3">
                  {!loading ? (
                    <ReactPaginate
                      previousLabel={"<<"}
                      breakLabel={"..."}
                      nextLabel={">>"}
                      pageCount={investData.pages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default TicketsList;
